<template>
  <multiselect
    v-model="selected"
    :options="options"
    track-by="id"
    :label="label"
    :placeholder="placeholder"
    :internal-search="false"
    open-direction="bottom"
    :loading="isLoading"
    class="custom-autocomplete-field"
    :class="[state !== null ? state ? 'is-valid' : 'is-invalid' : null]"
    :disabled="disabled"
    @search-change="debounceFetch"
    @select="updateData"
  />
</template>

<script>
import 'vue-multiselect/dist/vue-multiselect.min'
import Multiselect from 'vue-multiselect'
import { getCollection } from '@/shared/fetch-utils'

export default {
  name: 'CustomAutocompleteField',
  components: {
    Multiselect
  },
  props: {
    value: {
      type: Object,
      default: () => null
    },
    collection_type: {
      type: String,
      default: null
    },
    label: {
      type: String,
      default: 'name'
    },
    placeholder: {
      type: String,
      default: 'Select Option'
    },
    filters: {
      type: Array,
      default: () => []
    },
    searchField: {
      type: String,
      default: 'name'
    },
    disabled: {
      type: Boolean
    },
    state: {
      type: Boolean,
      default: null
    }
  },
  data () {
    return {
      isLoading: false,
      collection: null,

      selected: null,
    }
  },
  computed: {
    options () {
      return this.collection && this.collection.models || []
    }
  },
  watch: {
    collection_type () {
      if (this.collection_type) {
        this.fetch()
      }
    }
  },
  created () {
    this.debounceFetch = _.debounce((query) => this.fetch(query), 300)
  },
  mounted () {
    if (this.value) {
      this.selected = this.value
    }

    this.fetch()
  },
  methods: {
    async fetch (query) {
      if (!this.collection_type) return

      this.isLoading = true

      const filters = [
        ...this.filters
      ]

      if (query) {
        filters.push({
          logic: "filterContains",
          field: this.searchField,
          value: query
        })
      }

      this.collection = await getCollection({
        collection_type: this.collection_type,
        message: this.$bvToast,
        filters
      })

      this.isLoading = false
    },
    updateData (value) {
      this.$emit('input', value)
    }
  }
}
</script>
